import { create } from 'zustand';

export interface IUseTableStore {
  hoveringRow: string;
  setHoveringRow: (rowId: string) => void;
  unsetHoveringRow: () => void;
}

export const useTableStore = create<IUseTableStore>((set) => ({
  hoveringRow: '',
  setHoveringRow: (rowId) =>
    set(() => ({
      hoveringRow: rowId,
    })),
  unsetHoveringRow: () =>
    set(() => ({
      hoveringRow: undefined,
    })),
}));
